import type { EnderecoAr } from '@/types/arbitral/envioArTypes';

function apenasDigitosCep(cep: string): string {
  return cep.replace(/\D/g, '');
}

export function cepValido(cep: string): boolean {
  return apenasDigitosCep(cep).length === 8;
}

export function enderecoCompleto(endereco: EnderecoAr): boolean {
  return (
    cepValido(endereco.cep) &&
    endereco.logradouro.trim() !== '' &&
    endereco.numero.trim() !== '' &&
    endereco.bairro.trim() !== '' &&
    endereco.cidade.trim() !== '' &&
    endereco.uf.trim() !== ''
  );
}

/**
 * Uma linha só, sem o CEP — quem exibe decide se mostra o CEP separado. Formato usado tanto no
 * drawer da secretaria quanto no card que o requerente lê antes de autorizar o gasto.
 */
export function enderecoEmLinha(endereco: EnderecoAr): string {
  const complemento = endereco.complemento?.trim() ? `, ${endereco.complemento.trim()}` : '';
  return `${endereco.logradouro}, ${endereco.numero}${complemento} — ${endereco.bairro}, ${endereco.cidade}/${endereco.uf}`;
}
